import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import fieldPropTypes from './field';

const { arrayOf, bool, number, shape, string, oneOf, oneOfType } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  teamName: string,
  tableID: string,
  displayName: string,
  tableType: oneOf(['application', 'userDefined', 'process', 'team', 'user']),
  createdBy: string,
  createdDate: string,
  modifiedBy: string,
  modifiedDate: string,
  isArchived: bool,
  columns: arrayOf(oneOfType([fieldPropTypes, string])),
  visibility: string,
  visibleToUsers: arrayOf(string)
});



// WEBPACK FOOTER //
// ./js/types/api/table.js